export const getUserInformation = userId => {
  return `
          SELECT
            Email,
            FullPhotoUrl,
            Name
          FROM
              User
          WHERE
              Id = '${userId}'
          LIMIT 1
      `;
};
